// NOTE: NSAI-5890 — the mobile link redirector (apps/nsai/mobile-edge). A link
// to any tenant goes out as `https://go.nodeshift.com/t/<tenant-host>/<path>`:
// a browser is sent on to `https://<tenant-host>/<path>`, and a phone with the
// app opens it in the app. The app binary claims the same host and path at
// build time (associated domains and the intent filter in
// apps/nsai/mobile/app.config.ts); this is the runtime copy the app reads an
// incoming link with.
export const MOBILE_LINK_HOST = "go.nodeshift.com";
// NOTE: The only path the app claims, the same `/t/*` as APPLE_LINK_COMPONENT
// in apps/nsai/mobile-edge/config/src/constants/association.constants.ts.
export const MOBILE_LINK_TENANT_PATH = "/t/";
export const MOBILE_LINK_SCHEME = "https://";

// NOTE: A copy of HOST_PATTERN in
// apps/nsai/mobile-edge/config/src/constants/patterns.constants.ts, which is
// the source of truth — change both together. Lower-case DNS labels with at
// least one dot, and a top-level label that starts with a letter, so no IP
// literal and no single-label name like `localhost`; an optional `:port` with
// no leading zero. The redirector refuses every other shape, so the app does
// too.
const HOST_LABEL = "[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?";
const TOP_LEVEL_HOST_LABEL = "[a-z]([a-z0-9-]{0,61}[a-z0-9])?";
export const MOBILE_LINK_TENANT_HOST_PATTERN = new RegExp(
  `^(${HOST_LABEL}\\.)+${TOP_LEVEL_HOST_LABEL}(:[1-9][0-9]{0,4})?$`,
);
// NOTE: HOST_MAX_LENGTH and PORT_MAX in the same service's
// limits.constants.ts — the pattern alone admits ports up to 99999.
export const MOBILE_LINK_TENANT_HOST_MAX_LENGTH = 253;
export const MOBILE_LINK_TENANT_PORT_MAX = 65_535;
export const MOBILE_LINK_PORT_SEPARATOR = ":";

// NOTE: Where a host ends inside a URL: the first "/", "?" or "#".
export const MOBILE_LINK_HOST_END_PATTERN = /[/?#]/;
// NOTE: Global, so String#replace replaces every match. Use it with replace
// only, never with test or exec, which would carry lastIndex between calls.
export const MOBILE_LINK_ASCII_UPPER_CASE_PATTERN = /[A-Z]/g;
